import { useTranslation } from '@blocs.i18n';

export default function useAgGridText(): Record<string, string> {
  const { t } = useTranslation();

  return {
    selectAll: t('common:agGrid.selectAll'),
    selectAllSearchResults: t('common:agGrid.selectAllSearchResults'),
    searchOoo: t('common:agGrid.searchOoo'),
    blanks: t('common:agGrid.blanks'),
    noMatches: t('common:agGrid.noMatches'),
    filterOoo: t('common:agGrid.filterOoo'),
    equals: t('common:agGrid.equals'),
    notEqual: t('common:agGrid.notEqual'),
    blank: t('common:agGrid.blank'),
    notBlank: t('common:agGrid.notBlank'),
    empty: t('common:agGrid.empty'),
    lessThan: t('common:agGrid.lessThan'),
    greaterThan: t('common:agGrid.greaterThan'),
    lessThanOrEqual: t('common:agGrid.lessThanOrEqual'),
    greaterThanOrEqual: t('common:agGrid.greaterThanOrEqual'),
    inRange: t('common:agGrid.inRange'),
    inRangeStart: t('common:agGrid.inRangeStart'),
    inRangeEnd: t('common:agGrid.inRangeEnd'),
    contains: t('common:agGrid.contains'),
    notContains: t('common:agGrid.notContains'),
    startsWith: t('common:agGrid.startsWith'),
    endsWith: t('common:agGrid.endsWith'),
    dateFormatOoo: t('common:agGrid.dateFormatOoo'),
    andCondition: t('common:agGrid.andCondition'),
    orCondition: t('common:agGrid.orCondition'),
    applyFilter: t('common:agGrid.applyFilter'),
    resetFilter: t('common:agGrid.resetFilter'),
    clearFilter: t('common:agGrid.clearFilter'),
    cancelFilter: t('common:agGrid.cancelFilter'),
    textFilter: t('common:agGrid.textFilter'),
    numberFilter: t('common:agGrid.numberFilter'),
    dateFilter: t('common:agGrid.dateFilter'),
    setFilter: t('common:agGrid.setFilter'),
    columns: t('common:agGrid.columns'),
    filters: t('common:agGrid.filters'),
    pivotMode: t('common:agGrid.pivotMode'),
    groups: t('common:agGrid.groups'),
    rowGroupColumnsEmptyMessage: t('common:agGrid.rowGroupColumnsEmptyMessage'),
    values: t('common:agGrid.values'),
    valueColumnsEmptyMessage: t('common:agGrid.valueColumnsEmptyMessage'),
    pivots: t('common:agGrid.pivots'),
    pivotColumnsEmptyMessage: t('common:agGrid.pivotColumnsEmptyMessage'),
    group: t('common:agGrid.group'),
    loadingOoo: t('common:agGrid.loadingOoo'),
    noRowsToShow: t('common:agGrid.noRowsToShow'),
    enabled: t('common:agGrid.enabled'),
    pinColumn: t('common:agGrid.pinColumn'),
    pinLeft: t('common:agGrid.pinLeft'),
    pinRight: t('common:agGrid.pinRight'),
    noPin: t('common:agGrid.noPin'),
    valueAggregation: t('common:agGrid.valueAggregation'),
    autosizeThiscolumn: t('common:agGrid.autosizeThiscolumn'),
    autosizeAllColumns: t('common:agGrid.autosizeAllColumns'),
    groupBy: t('common:agGrid.groupBy'),
    ungroupBy: t('common:agGrid.ungroupBy'),
    addToValues: t('common:agGrid.addToValues'),
    removeFromValues: t('common:agGrid.removeFromValues'),
    addToLabels: t('common:agGrid.addToLabels'),
    removeFromLabels: t('common:agGrid.removeFromLabels'),
    resetColumns: t('common:agGrid.resetColumns'),
    expandAll: t('common:agGrid.expandAll'),
    collapseAll: t('common:agGrid.collapseAll'),
    copy: t('common:agGrid.copy'),
    ctrlC: t('common:agGrid.ctrlC'),
    copyWithHeaders: t('common:agGrid.copyWithHeaders'),
    copyWithHeaderGroups: t('common:agGrid.copyWithHeaderGroups'),
    paste: t('common:agGrid.paste'),
    ctrlV: t('common:agGrid.ctrlV'),
    export: t('common:agGrid.export'),
    csvExport: t('common:agGrid.csvExport'),
    excelExport: t('common:agGrid.excelExport'),
    sum: t('common:agGrid.sum'),
    min: t('common:agGrid.min'),
    max: t('common:agGrid.max'),
    none: t('common:agGrid.none'),
    count: t('common:agGrid.count'),
    avg: t('common:agGrid.avg'),
    filteredRows: t('common:agGrid.filteredRows'),
    selectedRows: t('common:agGrid.selectedRows'),
    totalRows: t('common:agGrid.totalRows'),
    totalAndFilteredRows: t('common:agGrid.totalAndFilteredRows'),
    more: t('common:agGrid.more'),
    to: t('common:agGrid.to'),
    of: t('common:agGrid.of'),
    page: t('common:agGrid.page'),
    nextPage: t('common:agGrid.nextPage'),
    lastPage: t('common:agGrid.lastPage'),
    firstPage: t('common:agGrid.firstPage'),
    previousPage: t('common:agGrid.previousPage'),
    pivotColumnGroupTotals: t('common:agGrid.pivotColumnGroupTotals'),
    pivotChartAndPivotMode: t('common:agGrid.pivotChartAndPivotMode'),
    pivotChart: t('common:agGrid.pivotChart'),
    chartRange: t('common:agGrid.chartRange'),
    columnChart: t('common:agGrid.columnChart'),
    groupedColumn: t('common:agGrid.groupedColumn'),
    stackedColumn: t('common:agGrid.stackedColumn'),
    normalizedColumn: t('common:agGrid.normalizedColumn'),
    barChart: t('common:agGrid.barChart'),
    groupedBar: t('common:agGrid.groupedBar'),
    stackedBar: t('common:agGrid.stackedBar'),
    normalizedBar: t('common:agGrid.normalizedBar'),
    pieChart: t('common:agGrid.pieChart'),
    pie: t('common:agGrid.pie'),
    doughnut: t('common:agGrid.doughnut'),
    line: t('common:agGrid.line'),
    xyChart: t('common:agGrid.xyChart'),
    scatter: t('common:agGrid.scatter'),
    bubble: t('common:agGrid.bubble'),
    areaChart: t('common:agGrid.areaChart'),
    area: t('common:agGrid.area'),
    stackedArea: t('common:agGrid.stackedArea'),
    normalizedArea: t('common:agGrid.normalizedArea'),
    histogramChart: t('common:agGrid.histogramChart'),
    pivotChartTitle: t('common:agGrid.pivotChartTitle'),
    rangeChartTitle: t('common:agGrid.rangeChartTitle'),
    settings: t('common:agGrid.settings'),
    data: t('common:agGrid.data'),
    format: t('common:agGrid.format'),
    categories: t('common:agGrid.categories'),
    defaultCategory: t('common:agGrid.defaultCategory'),
    series: t('common:agGrid.series'),
    xyValues: t('common:agGrid.xyValues'),
    paired: t('common:agGrid.paired'),
    axis: t('common:agGrid.axis'),
    navigator: t('common:agGrid.navigator'),
    color: t('common:agGrid.color'),
    thickness: t('common:agGrid.thickness'),
    xType: t('common:agGrid.xType'),
    automatic: t('common:agGrid.automatic'),
    category: t('common:agGrid.category'),
    number: t('common:agGrid.number'),
    time: t('common:agGrid.time'),
    xRotation: t('common:agGrid.xRotation'),
    yRotation: t('common:agGrid.yRotation'),
    ticks: t('common:agGrid.ticks'),
    width: t('common:agGrid.width'),
    height: t('common:agGrid.height'),
    length: t('common:agGrid.length'),
    padding: t('common:agGrid.padding'),
    spacing: t('common:agGrid.spacing'),
    chart: t('common:agGrid.chart'),
    title: t('common:agGrid.title'),
    titlePlaceholder: t('common:agGrid.titlePlaceholder'),
    background: t('common:agGrid.background'),
    font: t('common:agGrid.font'),
    top: t('common:agGrid.top'),
    right: t('common:agGrid.right'),
    bottom: t('common:agGrid.bottom'),
    left: t('common:agGrid.left'),
    labels: t('common:agGrid.labels'),
    size: t('common:agGrid.size'),
    minSize: t('common:agGrid.minSize'),
    maxSize: t('common:agGrid.maxSize'),
    legend: t('common:agGrid.legend'),
    position: t('common:agGrid.position'),
    markerSize: t('common:agGrid.markerSize'),
    markerStroke: t('common:agGrid.markerStroke'),
    markerPadding: t('common:agGrid.markerPadding'),
    itemSpacing: t('common:agGrid.itemSpacing'),
    itemPaddingX: t('common:agGrid.itemPaddingX'),
    itemPaddingY: t('common:agGrid.itemPaddingY'),
    layoutHorizontalSpacing: t('common:agGrid.layoutHorizontalSpacing'),
    layoutVerticalSpacing: t('common:agGrid.layoutVerticalSpacing'),
    strokeWidth: t('common:agGrid.strokeWidth'),
    offset: t('common:agGrid.offset'),
    offsets: t('common:agGrid.offsets'),
    tooltips: t('common:agGrid.tooltips'),
    callout: t('common:agGrid.callout'),
    markers: t('common:agGrid.markers'),
    shadow: t('common:agGrid.shadow'),
    blur: t('common:agGrid.blur'),
    xOffset: t('common:agGrid.xOffset'),
    yOffset: t('common:agGrid.yOffset'),
    lineWidth: t('common:agGrid.lineWidth'),
    normal: t('common:agGrid.normal'),
    bold: t('common:agGrid.bold'),
    italic: t('common:agGrid.italic'),
    boldItalic: t('common:agGrid.boldItalic'),
    predefined: t('common:agGrid.predefined'),
    fillOpacity: t('common:agGrid.fillOpacity'),
    strokeOpacity: t('common:agGrid.strokeOpacity'),
    histogramBinCount: t('common:agGrid.histogramBinCount'),
    columnGroup: t('common:agGrid.columnGroup'),
    barGroup: t('common:agGrid.barGroup'),
    pieGroup: t('common:agGrid.pieGroup'),
    lineGroup: t('common:agGrid.lineGroup'),
    scatterGroup: t('common:agGrid.scatterGroup'),
    areaGroup: t('common:agGrid.areaGroup'),
    histogramGroup: t('common:agGrid.histogramGroup'),
    groupedColumnTooltip: t('common:agGrid.groupedColumnTooltip'),
    stackedColumnTooltip: t('common:agGrid.stackedColumnTooltip'),
    normalizedColumnTooltip: t('common:agGrid.normalizedColumnTooltip'),
    groupedBarTooltip: t('common:agGrid.groupedBarTooltip'),
    stackedBarTooltip: t('common:agGrid.stackedBarTooltip'),
    normalizedBarTooltip: t('common:agGrid.normalizedBarTooltip'),
    pieTooltip: t('common:agGrid.pieTooltip'),
    doughnutTooltip: t('common:agGrid.doughnutTooltip'),
    lineTooltip: t('common:agGrid.lineTooltip'),
    groupedAreaTooltip: t('common:agGrid.groupedAreaTooltip'),
    stackedAreaTooltip: t('common:agGrid.stackedAreaTooltip'),
    normalizedAreaTooltip: t('common:agGrid.normalizedAreaTooltip'),
    scatterTooltip: t('common:agGrid.scatterTooltip'),
    bubbleTooltip: t('common:agGrid.bubbleTooltip'),
    histogramTooltip: t('common:agGrid.histogramTooltip'),
    noDataToChart: t('common:agGrid.noDataToChart'),
    pivotChartRequiresPivotMode: t('common:agGrid.pivotChartRequiresPivotMode'),
    chartSettingsToolbarTooltip: t('common:agGrid.chartSettingsToolbarTooltip'),
    chartLinkToolbarTooltip: t('common:agGrid.chartLinkToolbarTooltip'),
    chartUnlinkToolbarTooltip: t('common:agGrid.chartUnlinkToolbarTooltip'),
    chartDownloadToolbarTooltip: t('common:agGrid.chartDownloadToolbarTooltip'),
    ariaHidden: t('common:agGrid.ariaHidden'),
    ariaVisible: t('common:agGrid.ariaVisible'),
    ariaChecked: t('common:agGrid.ariaChecked'),
    ariaUnchecked: t('common:agGrid.ariaUnchecked'),
    ariaIndeterminate: t('common:agGrid.ariaIndeterminate'),
    ariaDefaultListName: t('common:agGrid.ariaDefaultListName'),
    ariaColumnSelectAll: t('common:agGrid.ariaColumnSelectAll'),
    ariaInputEditor: t('common:agGrid.ariaInputEditor'),
    ariaDateFilterInput: t('common:agGrid.ariaDateFilterInput'),
    ariaFilterList: t('common:agGrid.ariaFilterList'),
    ariaFilterInput: t('common:agGrid.ariaFilterInput'),
    ariaFilterColumnsInput: t('common:agGrid.ariaFilterColumnsInput'),
    ariaFilterValue: t('common:agGrid.ariaFilterValue'),
    ariaFilterFromValue: t('common:agGrid.ariaFilterFromValue'),
    ariaFilterToValue: t('common:agGrid.ariaFilterToValue'),
    ariaFilteringOperator: t('common:agGrid.ariaFilteringOperator'),
    ariaColumn: t('common:agGrid.ariaColumn'),
    ariaColumnList: t('common:agGrid.ariaColumnList'),
    ariaColumnGroup: t('common:agGrid.ariaColumnGroup'),
    ariaRowSelect: t('common:agGrid.ariaRowSelect'),
    ariaRowDeselect: t('common:agGrid.ariaRowDeselect'),
    ariaRowToggleSelection: t('common:agGrid.ariaRowToggleSelection'),
    ariaRowSelectAll: t('common:agGrid.ariaRowSelectAll'),
    ariaToggleVisibility: t('common:agGrid.ariaToggleVisibility'),
    ariaSearch: t('common:agGrid.ariaSearch'),
    ariaSearchFilterValues: t('common:agGrid.ariaSearchFilterValues'),
    ariaRowGroupDropZonePanelLabel: t('common:agGrid.ariaRowGroupDropZonePanelLabel'),
    ariaValuesDropZonePanelLabel: t('common:agGrid.ariaValuesDropZonePanelLabel'),
    ariaPivotDropZonePanelLabel: t('common:agGrid.ariaPivotDropZonePanelLabel'),
    ariaDropZoneColumnComponentDescription: t('common:agGrid.ariaDropZoneColumnComponentDescription'),
    ariaDropZoneColumnValueItemDescription: t('common:agGrid.ariaDropZoneColumnValueItemDescription'),
    ariaLabelColumnMenu: t('common:agGrid.ariaLabelColumnMenu'),
    ariaLabelCellEditor: t('common:agGrid.ariaLabelCellEditor'),
    ariaLabelDialog: t('common:agGrid.ariaLabelDialog'),
    ariaLabelSelectField: t('common:agGrid.ariaLabelSelectField'),
    ariaLabelTooltip: t('common:agGrid.ariaLabelTooltip'),
    ariaLabelContextMenu: t('common:agGrid.ariaLabelContextMenu'),
    ariaLabelSubMenu: t('common:agGrid.ariaLabelSubMenu'),
    ariaLabelAggregationFunction: t('common:agGrid.ariaLabelAggregationFunction'),
    thousandSeparator: t('common:agGrid.thousandSeparator'),
    decimalSeparator: t('common:agGrid.decimalSeparator'),
  };
}
